import React from 'react';
import AdCartsToys from './AdCartsToys';
import './AdProducts';

function AdProducts() {
  return (
    <div className='adproducts'>
      <h1>Products</h1>
      <AdCartsToys />
    </div>
  )
}

export default AdProducts;